import { formatDate } from "@/utils/date-format";
import { DatePickerView, Popup, Toast } from "antd-mobile";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.less";

interface Props {
  popVisible: boolean;
  close: () => void;
  getTimeRange: (startDate: string, endDate: string) => void;
}

const DatePicker: React.FC<Props> = (props: Props) => {
  //   const [popVisible, setpopVisible] = useState(true);
  const { popVisible, close, getTimeRange } = props;
  const tabList = [
    { name: "按月份", value: 1 },
    { name: "自定义", value: 2 },
  ];
  const now = new Date();
  const [curTabIndex, setCurTabIndex] = useState<number>(0);
  const [currentTimeIndex, setCurrentTimeIndex] = useState<number>(0);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [minDate, setMinDate] = useState(new Date(2017, 8, 1));
  const [maxDate, setMaxDate] = useState(new Date());
  const labelRenderer = useCallback((type: string, data) => {
    switch (type) {
      case "year":
        return data + "年";
      case "month":
        return data + "月";
      case "day":
        return data + "日";
      case "hour":
        return data + "时";
      case "minute":
        return data + "分";
      case "second":
        return data + "秒";
      default:
        return data;
    }
  }, []);
  const onClose = () => {
    close && close();
  };
  //   useEffect(() => {}, []);
  const timeChange = date => {
    if (currentTimeIndex === 0) {
      setStartDate(formatDate(date));
      setMinDate(date);
    } else if (currentTimeIndex === 1) {
      const endDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      let endDateStr = date;
      const isCurrentMonth =
        date.getMonth() === new Date().getMonth() &&
        date.getFullYear() === new Date().getFullYear();
      if (curTabIndex === 0) {
        endDateStr = isCurrentMonth ? new Date() : endDay;
      }
      setEndDate(formatDate(endDateStr));
      setMaxDate(endDateStr);
    }
  };
  const comfirm = () => {
    if (!startDate || !endDate) {
      Toast.show("请选择开始时间或结束时间");
      return;
    } else {
      getTimeRange(startDate, endDate);
      onClose();
    }
  };
  return (
    <Popup
      visible={popVisible}
      onMaskClick={onClose}
      bodyStyle={{
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        zIndex: 10000,
      }}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.cancel} onClick={onClose}>
            取消
          </div>
          <div className={styles.comfirm} onClick={comfirm}>
            确认
          </div>
        </div>

        <div className={styles.tab}>
          <div className={styles.mytabs}>
            {tabList.map((item, index) => {
              return (
                <div
                  className={` ${styles["tab-item"]} 
                  ${curTabIndex === index ? styles["active"] : styles[""]}
              `}
                  key={index}
                  onClick={() => {
                    setCurTabIndex(index);
                  }}>
                  {item.name}
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.time_title}>
          <div
            className={` ${styles["filter_time"]} 
            ${currentTimeIndex === 0 ? styles["active"] : styles[""]}
            ${startDate ? styles[""] : styles["empty"]}
              `}
            onClick={() => {
              setCurrentTimeIndex(0);
            }}>
            {startDate || "开始时间"}
          </div>
          <div>至</div>
          <div
            className={` ${styles["filter_time"]} 
            ${currentTimeIndex === 1 ? styles["active"] : styles[""]}
            ${endDate ? styles[""] : styles["empty"]}
              `}
            onClick={() => {
              setCurrentTimeIndex(1);
            }}>
            {endDate || "结束时间"}
          </div>
        </div>
        <div className={styles.date_picker}>
          <DatePickerView
            defaultValue={now}
            renderLabel={labelRenderer}
            precision={curTabIndex === 0 ? "month" : "day"}
            max={currentTimeIndex === 1 ? now : maxDate}
            min={currentTimeIndex === 0 ? new Date(2017, 8, 1) : minDate}
            onChange={val => {
              timeChange(val);
            }}
          />
        </div>
      </div>
    </Popup>
  );
};

export default DatePicker;
